import { DemoConfig } from "./demo.config";

// make sure that every path has a trailing slash! Consult docs/code/routing.md for more information
export const RouteConfig = {
  Home: "/",
  InvestmentPortfolio: "/investment-portfolio/",
  Settings: "/settings/",
  Success: "/success/",
  Signin: "/sign-in/",
  Signup: "/sign-up/",
  Onboarding: "/onboarding/",
  ViewProfile: "/profile/[userId]/",
  PredictiveSalary: "/predictive-salary/",
  News: "/news/",
  // Profile edit routes
  Edit: {
    Index: "/profile/edit/",
    PersonalInfo: "/profile/edit/personal-info/",
    Positions: "/profile/edit/positions/",
    WorkExperience: "/profile/edit/work-experience/",
    Volunteer: "/profile/edit/volunteer/",
    Education: "/profile/edit/education/",
    Skills: "/profile/edit/skills/",
    Certifications: "/profile/edit/certifications/",
    Recognition: "/profile/edit/recognition/",
  },
  BugReport: "/bug-report/",
  DemoHome: "/demo/",
  Profile: "/profile/",
  Guest: {
    Index: "/guest/",
    EditPositions: "/guest/edit/positions/",
  },
  VipPortfolios: "/vip-portfolios/",
  MyWallet: "/my-wallet/",
  Analytics: "/analytics/",
  Watchlist: "/watchlist/",
  Liveshow: "/liveshow/",
  CeoVsEmployee: "/ceo-vs-employee/",
  MyRewards: "/my-rewards/",
  BetaInvite: "/beta-invite/",
  BetaCheck: "/beta/check/",
  BetaIneligible: "/beta/ineligible/",
  Plaid: "/plaid/",

  // External links
  External: {
    Swag: "https://swag.lossdog.com/",
    PrivacyPolicy: "https://www.lossdog.com/privacy-policy/",
    TermsOfService: "https://www.lossdog.com/terms-of-use/",
    CryptoRewards: "https://lossdog.com/terms-of-use/#crypto-rewards",
  },

  // Demo routes
  Demo: DemoConfig.routes,
};

export const navigateToViewProfile = (userId: string) => {
  return RouteConfig.ViewProfile.replace("[userId]", userId);
};
